export const STORAGE = {
    ACCOUNT_ID: 'accountId',
    ACCOUNT_NAME: 'accountName',
    ACCOUNT_TYPE: 'accountType',
    ACCOUNT_PREMIUM: 'accountPremium',
    CORPORATE_ACCOUNT_TYPE: 'typeCorporate',
    ACCOUNT_CONFIRMED: 'confirmed',
    ACCOUNT_EMAIL: 'email',
    ACCOUNT_PHONE: 'phone',
    ADVERT_SELL: 'advertSell',
    ADVERT_RENT: 'advertRent',
    ADVERT_SERVICES: 'advertServices',
    ADVERT_PARTS: 'advertParts',
    ADVERT_PLACEMENT: 'advertPlacement',
    ADVERT_CHECKAUTO: 'advertCheckauto',
    COMPANY_ID: 'companyId',
};
